export default __webpack_public_path__ + "static/media/12-32-29.d316f8ea.jpg";